var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.09961,
    y: 8.10547,
    width: 2.69396,
    height: 7,
    transform: "rotate(29.1621 6.09961 8.10547)",
    fill: "#4DB27F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41291 16.587C1.58307 14.7571 1.58307 11.7904 3.41291 9.9605L9.9605 3.41291C11.7904 1.58307 14.7571 1.58307 16.587 3.41291C18.4168 5.24276 18.4168 8.20953 16.587 10.0394L10.0394 16.587C8.20953 18.4168 5.24276 18.4168 3.41291 16.587ZM7.99514 7.4996L11.0212 4.47357C12.2652 3.22951 14.2822 3.22951 15.5263 4.47357C16.7704 5.71763 16.7704 7.73466 15.5263 8.97872L12.5003 12.0047L7.99514 7.4996ZM6.47463 9.19658C6.76691 8.9043 7.24042 8.90468 7.53269 9.19698C7.82493 9.48925 7.82511 9.9629 7.53285 10.2552L6.22833 11.5597C5.75044 12.0376 5.55603 12.7764 5.40028 13.3684C5.36386 13.5068 5.32954 13.6372 5.29421 13.7544C5.2203 13.9995 5.02487 14.1909 4.77635 14.2523C4.29625 14.3708 3.70844 13.9127 3.80609 13.4279C3.99826 12.4738 4.31418 11.357 5.06265 10.6086L6.47463 9.19658Z",
    fill: "#4DB27F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPill);
export default __webpack_public_path__ + "static/media/icon-pill.5a1017dba29998a1589a14b902780132.svg";
export { ForwardRef as ReactComponent };